import {Component, inject} from '@angular/core'
import {RouterOutlet} from '@angular/router'
import {MatToolbar} from '@angular/material/toolbar'
import {MatIcon} from '@angular/material/icon'
import {MatIconButton} from '@angular/material/button'
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu'
import {ConfigService} from './services/config.service'
import {MatDivider} from '@angular/material/divider'
import {FormsModule} from '@angular/forms'

@Component({
  selector: 'ffs-root',
  imports: [
    RouterOutlet,
    MatToolbar,
    MatIcon,
    MatIconButton,
    MatMenuItem,
    MatMenu,
    MatMenuTrigger,
    MatDivider,
    FormsModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {

  public currentYear = new Date().getFullYear()

  public service = inject(ConfigService)
}
